import React,{useState} from "react";

function normalize(item){

if(!item){

return{
text:"Execution task",
priority:"MEDIUM",
effort:"MEDIUM",
impact:"MEDIUM"
};

}

if(typeof item==="string"){

return{

text:item,
priority:"MEDIUM",
effort:"MEDIUM",
impact:"MEDIUM"

};

}

return{

text:item.text || "Task",
priority:item.priority || "MEDIUM",
effort:item.effort || "MEDIUM",
impact:item.impact || "MEDIUM"

};

}

function priorityColor(priority){

if(priority==="HIGH")
return "bg-red-100 text-red-700";

if(priority==="MEDIUM")
return "bg-amber-100 text-amber-700";

return "bg-green-100 text-green-700";

}

export default function ExecutionChecklist({data}){

const checklist=(data?.checklist || [])
.filter(Boolean)
.map(normalize);

const [checked,setChecked]=useState([]);

function toggle(i){

if(checked.includes(i)){

setChecked(checked.filter(x=>x!==i));

}else{

setChecked([...checked,i]);

}

}

if(checklist.length===0){

return(

<div className="bg-white border rounded-xl p-6 shadow-sm">

<h3 className="text-lg font-semibold text-blue-900">
Founder Execution Checklist
</h3>

<p className="text-sm text-slate-500 mt-3">
No execution actions generated.
</p>

</div>

);

}

return(

<div className="bg-white border rounded-xl p-6 shadow-sm">

<h3 className="text-lg font-semibold text-blue-900">
Founder Execution Checklist
</h3>

<p className="text-sm text-slate-600 mt-1">
Immediate actions to start traction.
</p>

<div className="space-y-2 mt-4">

{checklist.map((item,i)=>(

<label
key={i}
className="flex items-start gap-3 text-sm bg-slate-50 border rounded-lg p-3 hover:bg-slate-100 transition"
>

<input
type="checkbox"
className="mt-1"
checked={checked.includes(i)}
onChange={()=>toggle(i)}
/>

<div>

<p className="text-slate-700">
{item.text}
</p>

<div className="flex gap-2 mt-1 flex-wrap">

<span className={`text-xs px-2 py-1 rounded ${priorityColor(item.priority)}`}>
{item.priority}
</span>

<span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded">
Effort {item.effort}
</span>

<span className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded">
Impact {item.impact}
</span>

</div>

</div>

</label>

))}

</div>

<div className="mt-5 text-xs text-slate-500">

Progress {checked.length}/{checklist.length} tasks completed

</div>

</div>

);

}